

















































































































































































































































































































import Vue from 'vue';
import ShipTooltip from '@/components/fleet/ShipTooltip.vue';
import ShipMaster from '@/classes/fleet/shipMaster';
import Const from '@/classes/const';
import SiteSetting from '@/classes/siteSetting';
import ShipStock from '@/classes/fleet/shipStock';
import SaveData from '@/classes/saveData/saveData';
import Ship from '@/classes/fleet/ship';
import ItemMaster from '@/classes/item/itemMaster';
import ShipValidation from '@/classes/fleet/shipValidation';

export interface ViewShip {
  ship: ShipMaster;
  count: number;
  area: number;
  level: number;
  /** 耐久 表示値 */
  hp: number;
  /** 運 表示値 */
  luck: number;
  /** 対潜 改修値!! */
  asw: number;
  expanded: boolean;
}

export default Vue.extend({
  name: 'ShipList',
  components: { ShipTooltip },
  props: {
    handleDecideShip: {
      type: Function,
      required: true,
    },
    handleChangeWidth: {
      type: Function,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    all: [] as ShipMaster[],
    ships: [] as { typeName: string; ships: ViewShip[] }[],
    types: [] as { text: string; types: number[] }[],
    type: 0,
    isFinalOnly: true,
    keyword: '',
    multiLine: true,
    isStockOnly: false,
    shipStock: [] as ShipStock[],
    usedShips: [] as Ship[],
    confirmDialog: false,
    confirmShip: {} as ViewShip,
    setting: new SiteSetting(),
    daihatsuOK: false,
    naikateiOK: false,
    fighterOK: false,
    hasAreaOnly: false,
    isReleaseExSlotOnly: false,
    maxAreas: 0,
    disabledStockOnlyChange: false,
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipShip: new Ship(),
    tooltipX: 0,
    tooltipY: 0,
  }),
  mounted() {
    this.maxAreas = this.$store.state.areaCount as number;
    const existTypes: number[] = [];
    const ships = this.$store.state.ships as ShipMaster[];
    for (let i = 0; i < ships.length; i += 1) {
      const ship = ships[i];
      this.all.push(ship);
      if (!existTypes.includes(ship.type)) {
        existTypes.push(ship.type);
      }
    }
    for (let i = 0; i < Const.SHIP_TYPES_ALT.length; i += 1) {
      const data = Const.SHIP_TYPES_ALT[i];
      if (data.types.some((v) => existTypes.includes(v))) {
        this.types.push({ text: data.text, types: data.types });
      }
    }
  },
  methods: {
    changeType(index = 0) {
      this.type = index;
      this.filter();
    },
    clickedStockOnly() {
      this.setting.isStockOnlyForShipList = this.isStockOnly;
      this.$store.dispatch('updateSetting', this.setting);
      this.filter();
    },
    initialize(enabledUserShip = true) {
      // 現行の在籍艦娘情報を更新
      this.shipStock = this.$store.state.shipStock as ShipStock[];
      this.setting = this.$store.state.siteSetting as SiteSetting;
      this.isStockOnly = this.setting.isStockOnlyForShipList || this.disabledStockOnlyChange;

      // 設置値復元
      this.isFinalOnly = this.setting.savedShipListFilter.isFinalOnly;

      // 一時所持情報データがあるなら
      if (this.$store.getters.getExistsTempStock) {
        this.shipStock = this.$store.state.tempShipStock as ShipStock[];
        this.isStockOnly = !!this.shipStock.length;
      }

      // 現在の計算画面内で配備されている艦娘を列挙する
      this.usedShips = [];
      const mainData = this.$store.state.mainSaveData as SaveData;
      const manager = mainData.tempData[mainData.tempIndex];
      if (enabledUserShip && manager) {
        let allShips: Ship[] = [];
        for (let i = 0; i < manager.fleetInfo.fleets.length; i += 1) {
          if (i === 4) {
            // 友軍は除外
            continue;
          }
          const fleet = manager.fleetInfo.fleets[i];
          allShips = allShips.concat(fleet.ships.filter((v) => v.data.id > 0));
        }

        this.usedShips = allShips;
      }

      this.changeMultiLine(this.setting.isMultiLineForShipList);
      this.filter();
    },
    filter() {
      const word = this.keyword;
      let result = this.all.concat();
      const t = this.types[this.type];

      this.setting.savedShipListFilter.isFinalOnly = this.isFinalOnly;
      this.$store.dispatch('updateSetting', this.setting);

      // 検索語句あればこれ以外の検索はしない
      if (word) {
        result = result.filter((v) => v.albumId === +word || v.name.indexOf(word) >= 0);
      } else {
        // カテゴリ検索
        result = result.filter((v) => t.types.includes(v.type));
        const isValid = ShipValidation.isValidItem;
        if (this.isFinalOnly) {
          // 最終改造状態ONLY
          result = result.filter((v) => v.isFinal);
        }
        if (this.daihatsuOK) {
          // 大発搭載可能
          const daihatsu = (this.$store.state.items as ItemMaster[]).find((v) => v.id === 68);
          if (daihatsu) {
            result = result.filter((v) => isValid(v, daihatsu));
          }
        }
        if (this.naikateiOK) {
          // 内火艇搭載可能
          const naikatei = (this.$store.state.items as ItemMaster[]).find((v) => v.id === 167);
          if (naikatei) {
            result = result.filter((v) => isValid(v, naikatei));
          }
        }
        if (this.fighterOK) {
          // 戦闘機搭載可
          const fighter = (this.$store.state.items as ItemMaster[]).find((v) => v.id === 19);
          const fighter2 = (this.$store.state.items as ItemMaster[]).find((v) => v.id === 165);
          if (fighter && fighter2) {
            result = result.filter((v) => isValid(v, fighter) || isValid(v, fighter2));
          }
        }
      }

      let usedShips = this.usedShips.concat();
      let viewShips: ViewShip[] = [];
      if (this.isStockOnly && this.shipStock.length) {
        // 在籍艦娘考慮
        const stock = this.shipStock;
        for (let i = 0; i < result.length; i += 1) {
          const master = result[i];
          const stockData = stock.filter((v) => v.id === master.id);
          if (!stockData.length) {
            // 未所持 出さない
            continue;
          }

          const ships: ViewShip[] = [];
          for (let j = 0; j < stockData.length; j += 1) {
            const shipData = stockData[j];
            const viewShip: ViewShip = {
              ship: master,
              count: 1,
              level: shipData.level,
              hp: shipData.improvement.hp + (shipData.level > 99 ? master.hp2 : master.hp),
              luck: shipData.improvement.luck + master.luck,
              asw: shipData.improvement.asw,
              area: shipData.area <= this.maxAreas ? Math.max(shipData.area, 0) : 0,
              expanded: shipData.releaseExpand,
            };

            // 補強増設開放済み検索
            if (this.isReleaseExSlotOnly && !viewShip.expanded) {
              continue;
            }
            // 札あり限定検索
            if (this.hasAreaOnly && viewShip.area <= 0) {
              continue;
            }

            // id 練度 運 対潜 耐久 海域を見て配備済みかどうか判定
            const usedIndex = usedShips.findIndex(
              (v) => v.data.id === master.id
                && v.level === viewShip.level
                && v.hp === viewShip.hp
                && v.luck === viewShip.luck
                && v.area === viewShip.area
                && v.improveAsw === viewShip.asw,
            );
            if (usedIndex >= 0) {
              // 配備済みなら減らす
              viewShip.count = 0;
              usedShips = usedShips.filter((v, index) => index !== usedIndex);
            }

            // まとめられそうな艦娘がいないか？(id 練度 運 対潜 耐久 海域 増設 が一致)
            const search = ships.find(
              (v) => v.ship.id === viewShip.ship.id
                && v.level === viewShip.level
                && v.luck === viewShip.luck
                && v.area === viewShip.area
                && v.hp === viewShip.hp
                && v.asw === viewShip.asw
                && v.expanded === viewShip.expanded,
            );
            if (search) {
              // いたらcountだけインクリメント
              search.count += viewShip.count;
            } else {
              // いなければ追加
              ships.push(viewShip);
            }
          }

          if (ships.length) {
            viewShips = viewShips.concat(ships);
          }
        }
      } else {
        // 所持装備考慮なし 愚直に追加
        for (let i = 0; i < result.length; i += 1) {
          const master = result[i];
          viewShips.push({
            ship: master,
            count: 1,
            level: 99,
            hp: master.hp,
            luck: master.luck,
            area: -1,
            asw: 0,
            expanded: false,
          });
        }
      }

      // 艦型に応じて分けたい
      const altTypes = Const.SHIP_TYPES_ALT_INFO;
      const resultShips = [];
      for (let i = 0; i < altTypes.length; i += 1) {
        const type = altTypes[i];
        const ships = viewShips.filter((v) => v.ship.type2 === type.id);
        if (ships.length) {
          // 母港ソート
          ships.sort((a, b) => a.ship.sort - b.ship.sort);
          // 存在する艦型を生成
          resultShips.push({ typeName: type.name, ships });
        }
      }

      this.ships = resultShips;
    },
    clickedShip(ship: ViewShip) {
      if (ship.count || this.confirmDialog) {
        this.confirmDialog = false;
        this.handleDecideShip(ship);
      } else {
        this.confirmShip = ship;
        this.confirmDialog = true;
      }
    },
    close() {
      this.handleClose();
    },
    changeMultiLine(isMulti: boolean) {
      this.handleChangeWidth(isMulti ? 1200 : 660);
      this.multiLine = isMulti;
      // 設定書き換え
      this.setting.isMultiLineForShipList = isMulti;
      this.$store.dispatch('updateSetting', this.setting);
    },
    bootTooltip(viewShip: ViewShip, e: MouseEvent) {
      this.tooltipTimer = window.setTimeout(() => {
        this.tooltipX = e.clientX;
        this.tooltipY = e.clientY;

        const baseAsw = Ship.getStatusFromLevel(viewShip.level, viewShip.ship.maxAsw, viewShip.ship.minAsw);
        const ship = new Ship({
          master: viewShip.ship,
          hp: viewShip.hp,
          level: viewShip.level,
          luck: viewShip.luck,
          asw: baseAsw + viewShip.asw,
        });
        this.tooltipShip = ship;
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
